import { Flex } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { EvaluationDepartmentSummaryPdfButton } from '@/module/Evaluation/components/EvaluationDepartmentSummaryPdfButton';
import { EvaluationDepartmentSummaryXlsxButton } from '@/module/Evaluation/components/EvaluationDepartmentSummaryXlsxButton';
import { EvaluationDepartmentSummaryFile } from '@/module/Evaluation/components/files/EvaluationDepartmentSummaryFile';
import { getEvaluationDepartmentSummaryFileOptions } from '@/module/Evaluation/model/EvaluationQuery';

import { Id } from '@feature/utils';

interface EvaluationDepartmentSummaryProps {
  departmentId: number;
  evaluationId: Id;
}

export function EvaluationDepartmentSummary({ departmentId, evaluationId }: EvaluationDepartmentSummaryProps) {
  const { data: file } = useSuspenseQuery(getEvaluationDepartmentSummaryFileOptions(evaluationId, departmentId));
  return (
    <>
      <Flex gap="10px">
        <EvaluationDepartmentSummaryPdfButton
          departmentId={departmentId}
          evaluationId={evaluationId}
        />
        <EvaluationDepartmentSummaryXlsxButton
          departmentId={departmentId}
          evaluationId={evaluationId}
        />
      </Flex>
      <EvaluationDepartmentSummaryFile
        file={file}
        evaluationId={evaluationId}
        departmentId={departmentId}
      />
    </>
  );
}
